import { useParams } from "react-router-dom";
import { PluginContainer } from "../../Plugins";
import { useGetPluginsQuery, useGetAppsQuery } from "../services";
import { usePagination } from "../../../hooks";
import { FMDPStorage } from "../../../shared/helper";

// MPPluginContainer is a wrapper for PluginContainer in the Management Portal
// It finds and passes the selected plugin to PluginContainer
export const MPPluginContainer = () => {
  let params = useParams();

  const userApp = FMDPStorage.get("selected-app");

  const { page, setPage, perPage, pagination } = usePagination();

  const {
    data = { data: [], total_count: 0 },
    isFetching,
    isSuccess,
    error,
  } = useGetPluginsQuery({
    page,
    per_page: perPage,
    order_by: "plugins.created_at",
    order_dir: "desc",
  });

  // Get list of apps subscribed by client
  const { data: clientApp = { data: [] }, isSuccess: clientAppSuccess } = useGetAppsQuery();

  // Check if plugin is supported by currently selected app
  const isPluginSupportedByApp = (plugin) =>
    plugin.permission.map((app_id) => clientApp.data[app_id - 1]?.name
      .replace(/\s+/g, '')).includes(userApp);

  const selectedPlugin = data.data.find((plugin) =>
    plugin.path === params.path && isPluginSupportedByApp(plugin)
  );

  return <PluginContainer selectedPlugin={selectedPlugin} isSuccess={isSuccess} data={data} />
};
